//
//
//
//
//
//


export default {
  components: {
  },
  data () {
    return {
      // note: changing this line won't causes changes
      // with hot-reload because the reloaded component
      // preserves its current state and we are modifying
      // its initial state.
    }
  },
  created(){

  },
  methods:{

  },
  watch: {
    
  },
  computed:{
    
  }
}



// WEBPACK FOOTER //
// ./src/components/article.vue